import { render } from "./transactions-list.component.vue?vue&type=template&id=4ef32484&ts=true"
import script from "./transactions-list.component.vue?vue&type=script&lang=ts"
export * from "./transactions-list.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__